import ConfirmationModal from "./Components/ConfirmationModal";

export default ConfirmationModal;
